type IndustrialCaseMediaCaptionProps = {
  caption: string;
};

/**
 * ### IndustrialCaseMediaCaption
 *
 * Presents only the author-written media explanation. Empty descriptions omit
 * the caption entirely so storage file names never leak into public previews.
 *
 * @param props Author-written media caption
 * @returns Semantic figure caption content shared by audio and video players
 */
export function IndustrialCaseMediaCaption({
  caption,
}: IndustrialCaseMediaCaptionProps) {
  const description = caption.trim();
  if (!description) return null;

  return (
    <figcaption className="mt-3 block text-sm leading-[1.6] text-[#555550]">
      <span>{description}</span>
    </figcaption>
  );
}
